define.alias("shared/components/shared/ui/social-profile-switcher/linkinbio/item", "settings/components/shared/ui/social-profile-switcher/linkinbio/item");